import { render } from "./AtencionAlCliente.vue?vue&type=template&id=15163fd0"
import script from "./AtencionAlCliente.vue?vue&type=script&lang=js"
export * from "./AtencionAlCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__